// @ts-strict-ignore
import { Colors } from "themes/color-palette";
import type { TextOptions, TypographyPresetType } from "./index";
import { FontWeight } from "./index";

export const getResponsiveProps = (
  base: TypographyPresetType,
  overrides: TypographyPresetType = {}
) => {
  const {
    sm = {},
    md = {},
    lg = {},
    lgV1 = {},
    smV1 = {},
    mdV1 = {}
  } = overrides;
  const {
    sm: baseSm = {},
    md: baseMd = {},
    lg: baseLg = {},
    lgV1: baseLgV1 = {},
    smV1: baseSmV1 = {},
    mdV1: baseMdV1 = {}
  } = base;
  return {
    sm: { ...baseSm, ...sm },
    md: { ...baseMd, ...md },
    lg: { ...baseLg, ...lg },
    lgV1: { ...baseLgV1, ...lgV1 },
    smv1: { ...baseSmV1, ...smV1 },
    mdv1: { ...baseMdV1, ...mdV1 }
  };
};

export const getFontStyles = (options: TextOptions) => {
  let style = "";
  if (options) {
    const {
      fontSize,
      lineHeight,
      letterSpacing,
      display,
      textAlign,
      m,
      mb,
      mt,
      ml,
      mr,
      maxWidth,
      color,
      fontWeight
    } = options;
    if (display) style += `display: ${display};`;
    if (fontSize) style += `font-size: ${fontSize};`;
    if (color) style += `color: ${color};`;
    if (fontWeight) style += `font-weight: ${fontWeight};`;
    if (lineHeight) style += `line-height: ${lineHeight};`;
    if (textAlign) style += `text-align: ${textAlign};`;
    if (letterSpacing) style += `letter-spacing: ${letterSpacing}px;`;
    if (maxWidth) style += `max-width: ${maxWidth};`;
    if (m) style += `margin: ${m};`;
    if (ml) style += `margin-left: ${ml};`;
    if (mr) style += `margin-right: ${mr};`;
    if (mt) style += `margin-top: ${mt};`;
    if (mb) style += `margin-bottom: ${mb};`;
  }

  return style;
};

export const getFontColor = (color, theme) => {
  return color
    ? `color: ${theme.textColors[color] || Colors[color] || color};`
    : `color: ${theme.textColors.primary};`;
};

export const getFontWeight = (bold, semiBold, extraBold, bold600) => {
  return `font-weight: ${
    extraBold
      ? FontWeight.extraBold
      : bold
        ? FontWeight.bold
        : semiBold
          ? FontWeight.semiBold
          : bold600
            ? FontWeight.bold600
            : FontWeight.regular
  };`;
};

export const getTextDecoration = (underline, strikethrough) => {
  let style = "";
  if (underline) style += "underline ";
  if (strikethrough) style += "line-through";
  return style ? `text-decoration: ${style};` : null;
};

export const capitalize = (str: string) => {
  const lowerCase = str.toLowerCase();
  return str.charAt(0).toUpperCase() + lowerCase.slice(1);
};

export const getWeight = (bold: boolean, semiBold: boolean): number =>
  bold ? 700 : semiBold ? 600 : 400;
